<div class="materialTabbgWrapper">
  <p class="px-3 py-4">{{'common.text_coreSearchTab_content'|cxTranslate}}</p>
  <div [ngClass]="isMobile ? 'searchContainermob' : 'searchContainer row mx-0'">
    <div class="searchBox1" [class.opacitifier]="(searchQuery1.length === 0)">
      <input type="text" [(ngModel)]="searchQuery1" placeholder="{{'common.text_core_search_partNumber'|cxTranslate}}"
        [disabled]="searchQuery2.length === 1 " (keydown.Enter)="search1ApiCall(0)">
      <button class="btn btn_blue_core searchbtn" (click)="search1ApiCall(0)"
        [disabled]="searchQuery1.length === 0 || searchQuery1.length === 0">{{'common.search_meta_title'|cxTranslate}}
        <img class="img-hover" src="/icons/link-grey.svg" width="20px" alt=""></button>
    </div>
    @if (caller !== 'submitCore') {
    <div class="searchBreaker">{{'common.text_core_search_or'|cxTranslate}}
    </div>
    <div class="searchBox2" [class.opacitifier]="(searchQuery2.length === 0)">
      <input type="text" [(ngModel)]="searchQuery2" placeholder="{{'common.text_core_search_coreGroup'|cxTranslate}}"
        [disabled]="searchQuery1.length === 1" (keydown.Enter)="search2ApiCall(0)">
      <button class="btn searchbtn" (click)="search2ApiCall(0)"
        [disabled]="searchQuery2.length === 0 || searchQuery2.length === 0">{{'common.search_meta_title'|cxTranslate}}
        <img class="img-hover" src="/icons/link-grey.svg" width="20px" alt=""></button>
    </div>
    }

  </div>
  <p class="px-3 pb-5 pt-4">{{'common.text_Shipping_Packaging_content1'|cxTranslate}} <a
      href="mailto:cores@bendix.com">cores&#64;bendix.com</a>.
    {{'common.text_Shipping_Packaging_content2'|cxTranslate}}</p>
  @if (tableContent?.noResult) {
  <p class="mt-0 pb-3 pl-3">{{'common.text_coreSearchTab_error'|cxTranslate}}</p>
  }
</div>
<!-- table section -->
@if (tableContent?.products && tableContent?.products?.length>0) {
<div [class.res_table_section]="isMobile">
  <div class="account-overview-table mycompany-manageUser mt-2">
    <table class="responsive-table table table-bordered table-blue">
      <thead>
        <tr class="responsive-table-head hidden-xs hidden-sm">
          <th scope="col">{{'common.text_core_search_partnum'|cxTranslate}}</th>
          <th scope="col">{{'common.text_type_number'|cxTranslate}}</th>
          <th scope="col">{{'common.text_description'|cxTranslate}}</th>
          <th scope="col">{{'common.text_market'|cxTranslate}}</th>
          <th scope="col">{{'common.text_core_group'|cxTranslate}}</th>
          <th scope="col">{{'common.text_core_class'|cxTranslate}}</th>
          <th scope="col"></th>
        </tr>
      </thead>
      @if (tableContent) {
      <tbody>
        @for (item of tableContent?.products; track item) {
        <tr class="responsive-table-item">
          <td class="responsive-table-cell">
            <a routerLink="/c/{{item?.name}}/product/p/{{item?.code}}">
              <span class="mycompnay-registration-value pointer">
                {{item?.code}}
              </span></a>
          </td>
          <td class="responsive-table-cell">
            <span class="mycompnay-registration-value">
              {{item?.typenumber}}
            </span>
          </td>
          <td class="responsive-table-cell">
            <span class="mycompnay-registration-value" [innerHTML]="item?.name">
            </span>
          </td>
          <td class="responsive-table-cell">
            <span class="mycompnay-registration-value">
              {{item?.marketType}}
            </span>
          </td>
          <td class="responsive-table-cell">
            <span class="mycompnay-registration-value">
              {{item?.coreGroup}}&nbsp;&nbsp;{{item?.coreGroupDescription}}
            </span>
          </td>
          <td class="responsive-table-cell">
            <span class="mycompnay-registration-value">
              {{item?.coreClass}}&nbsp;&nbsp;{{item?.coreClassDescription}}
            </span>
          </td>
          <td>
            @if (item?.coreGroup) {
            @if (item?.showAddToCoreFormBtn) {
            <span class="mycompnay-registration-value">
              <button (click)="addToCoreForm(item)"
                class="btn btn-blue coloeaddtocoe">{{'common.text_add_to_core_form'|cxTranslate}}</button>
            </span>
            }
            }
            @if (!item?.showAddToCoreFormBtn) {
            <span>{{'common.core_number_not_available'|cxTranslate}}</span>
            }
          </td>
        </tr>
        }
      </tbody>
      }
    </table>
  </div>
  @if (tableContent?.pagination) {
  <div class="account-orderhistory-pagination company-users-pagination">
    <div class="product__list--wrapper mt-4">
      <div class="pagination-bar">
        <div class="pagination-toolbar">
          <div class="row sort-refine-bar">
            <div class="col-xs-12 col-sm-6 col-md-6 bottom-result">
              <div class="pagination-result">
                <label>{{'common.search_page_showing_text'|cxTranslate}}
                  {{($any(tableContent)?.pagination.pageSize *
                  $any(tableContent)?.pagination.currentPage)+1 }}-
                  @if ($any(tableContent)?.pagination.pageSize *($any(tableContent)?.pagination.currentPage+1) <
                    $any(tableContent)?.pagination.totalResults) { <span>{{$any(tableContent)?.pagination.pageSize
                    *($any(tableContent)?.pagination.currentPage+1)}}</span>
                    }
                    @if ($any(tableContent)?.pagination.pageSize *($any(tableContent)?.pagination.currentPage+1) >
                    $any(tableContent)?.pagination.totalResults) {
                    <span>{{$any(tableContent)?.pagination.totalResults}}</span>
                    }
                    {{'common.search_page_of_text'|cxTranslate}} {{$any(tableContent)?.pagination.totalResults}}
                    {{'common.search_page_result_text'|cxTranslate}}</label>
              </div>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 kb-pagination-right kb-pagination" [ngClass]="isMobile? 'mb-3': ''">
              <kb-pagination [pagination]="$any(tableContent)?.pagination" [defaultPage]="0"
                (viewPageEvent)="changePageCustom($event, $any(tableContent)?.searchPageData)"></kb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
}